import { render, staticRenderFns } from "./TheHeaderDropdownAccnt.vue?vue&type=template&id=10bcdd5b&scoped=true&"
import script from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownAccnt.vue?vue&type=style&index=0&id=10bcdd5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bcdd5b",
  null
  
)

export default component.exports